<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>Access</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/settings/access">Access</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" @click="showModal()"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-row>
            <b-col md='8' class="mb-3">
                <div class="d-flex">
                    <span class="my-3 dashboard-access active"><router-link to="/access/user-access" style="color:#0056b3!important;">{{$route.name}}</router-link></span>
                    <span class="ml-4 my-3 dashboard-access"><router-link to="/settings/access/module-access">Module Access</router-link></span>
                </div>
            </b-col>
        </b-row>
        <div class="border-bottom mb-5"></div>
        <paginated-table ref="dataTable" :can-delete="false" :can-show="false" :can-view="false" :can-download="false" :can-edit="false" :can-edit-modal="false" :can-reject="false" :can-approve="false" :can-print="false" :data-url="apiUrl.userAccess" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
        <b-modal ref="my-modal" centered hide-footer title="Add Access">
            <form v-on:submit.prevent="doSubmit">
                <label for="" class="mt-2 labels">Name *</label>
                <typeahead2 ref="technicianTypeahead" :preventAutofocus="false" :required="true" :labelFields="['firstName', 'lastName']" :placeholder="'Enter Name'" :urlSearch="apiUrl.profile" arr-response="profile" :model="tableFilter.employee" customQueryParamName="search" />
                <label for="" class="mt-4 labels">Staff Id </label>
                <input class="mb-2 form-control" id="field-type" readonly v-model="model.staffId" v-bind:class="errors.has('staffId') ? 'is-invalid':''" data-vv-as="staffId" name="staffId" placeholder="Enter Staff ID" />
                <label for="" class="mt-3 labels">Role *</label>
                <b-form-select class="mb-2" v-model="model.role" required :options="roleList" />
                <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
                <b-button class="mt-3 float-right" variant="primary" @click="doSubmit()" type="submit"><font-awesome-icon icon="save"></font-awesome-icon>{{this.model.uuid !== null ? ' Update' : ' Submit'}} </b-button>
            </form>
        </b-modal>
        <edit-access-modal ref="editAccess" v-on:getAccess="getAccess"></edit-access-modal>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import EditAccessModal from '@/pages/Settings/Access/UserAccess/EditAccessModal'
    import Typeahead2 from '@/components/Typeahead2'
    import Vue from 'vue'

    export default {
        name: 'access',
        components: {
            PaginatedTable,
            EditAccessModal,
            Typeahead2
        },
        data () {
            return {
                dataItem: [],
                dataKey: 'user_access',
                isLoading: false,
                apiUrl: {
                    userAccess: window.AppConfig.apiUrl + 'user-access',
                    profile: window.AppConfig.apiUrl + 'profile?active=1'
                },
                model: {
                    uuid: null,
                    staffId: null,
                    role: null
                },
                modelValidations: {
                    name: {
                        required: true
                    },
                    staffId: {
                        required: true
                    },
                    role: {
                        required: true
                    }
                },
                roleList: [
                    {
                        value: null,
                        text: 'Please Select Role'
                    }
                ],
                columns: [
                    {
                        key: 'fullNameAccess',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'usernameAccess',
                        label: 'Staff ID',
                        sortable: false
                    },
                    {
                        key: 'roleAccess',
                        label: 'Role',
                        sortable: false
                    },
                    {
                        key: 'actionAccess',
                        label: '',
                        sortable: false
                    }
                ],
                tableFilter: {
                    employee_name: this.$route.query.employee_name,
                    employee: {
                        value: null
                    }
                }
            }
        },
        watch: {
            'tableFilter.employee.value'(value) {
                if (this.tableFilter.employee.value !== null) {
                    this.getEmployeeByEmail(value)
                } else {
                    this.model.staffId = null
                }
            }
        },
        mounted() {
            this.getAccess()
            this.getEmployeeName()
            this.getRoleName()
        },
        methods: {
            getAccess () {
                this.isLoading = true
                this.$refs.dataTable.getDataTable()
            },
            getEmployeeName() {
                this.$http.get(window.AppConfig.apiUrl + 'profile').then(response => {
                    response.data._embedded.profile.forEach(data => {
                        let names = data.firstName + '\xa0' + data.lastName
                        this.fullName = names
                        this.dataItem.push({
                            value: data.uuid,
                            text: this.fullName
                        })
                    })
                })
            },
            getRoleName() {
                this.$http.get(window.AppConfig.apiUrl + 'user-role').then(response => {
                    response.data._embedded.user_role.forEach(data => {
                        if (data.uuid !== '6b24e192-2f2a-48ff-8325-00707ae5ce1f' && data.name !== 'USER') {
                            this.roleList.push({
                                value: data.uuid,
                                text: data.name
                            })
                        }
                    })
                })
            },
            getEmployeeByEmail (uuid) {
                this.$http.get(window.AppConfig.apiUrl + 'profile' + '/' + uuid).then(response => {
                    let usernames = response.data.username
                    this.model.staffId = usernames
                })
            },
            showModal() {
                this.model.uuid = null
                this.model.name = null
                this.model.staffId = null
                this.model.email = null
                this.model.role = null
                this.$validator.reset();
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        this.$http.post(this.apiUrl.userAccess, {
                            userProfile: this.tableFilter.employee.value,
                            userRole: this.model.role
                        }).then(response => {
                            this.$store.dispatch('notification/success', 'Access data successfully added.')
                            this.$refs.dataTable.doFilter()
                            this.hideModal()
                        })
                    }
                })
            }
            // doEdit (row) {
            //     this.$refs.editAccess.showModal(row)
            // }
        }
    }
</script>
<!--<style scoped>
    @import url(https://cdn.syncfusion.com/ej2/material.css);
</style>-->